import React, { useEffect, useRef, useState } from "react"
import { Chart as ChartJs } from "chart.js"
import { connect } from "react-redux"
import classNames from "classnames"
import PropTypes from "prop-types"

import { useChartData } from "../../hooks/useChartData"

import Typograph from "components/Typograph"
import SelectPeriod from "../SelectPeriod"

import styles from "./styles.css"

const Chart = ({ profileData }) => {
  const canvasRef = useRef(null)
  const [periods, setPeriods] = useState([])
  const { parsedData, currentData, currentChartData, handleCurrentData } =
    useChartData(profileData, periods)

  const renderChart = () => {
    const ctx = canvasRef.current.getContext("2d")
    const chart = new ChartJs(ctx, {
      type: "bar",
      data: {
        labels: currentChartData.months,
        datasets: [
          {
            label: currentChartData.dataLabel,
            data: currentChartData.data,
            backgroundColor: currentChartData.color,
            borderSkipped: false,
            barThickness: 48
          }
        ]
      },
      options: {
        responsive: true,
        legend: {
          display: false
        },
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                fontSize: 14,
                fontStyle: "700",
                fontColor: "#3C4646"
              },
              scaleLabel: {
                display: true,
                labelString: "Consumo (MB / Mensagens / Minutos)",
                fontSize: 16,
                fontStyle: "bold",
                fontColor: "#3C4646"
              }
            }
          ],
          xAxes: [
            {
              ticks: {
                fontSize: 14,
                fontStyle: "700",
                fontColor: "#3C4646"
              },
              scaleLabel: {
                display: true,
                labelString: "Meses",
                fontSize: 16,
                fontStyle: "bold",
                fontColor: "#3C4646"
              }
            }
          ]
        }
      }
    })

    return () => {
      chart.destroy()
    }
  }

  useEffect(renderChart, [currentChartData, periods])

  return (
    <div>
      <Typograph
        htmlTag="h2"
        size="medium"
        weight="semi_bold"
        color="outer_space"
      >
        Use as abas abaixo para navegar entre as categorias:
      </Typograph>

      <SelectPeriod months={currentData.months} onChange={setPeriods} />

      <Typograph
        htmlTag="p"
        size="small"
        weight="semi_bold"
        color="outer_space"
        classNames={styles.textLeft}
      >
        *Você pode consultar os dados registrados nos últimos 6 meses
      </Typograph>

      <div className={styles.containerBtn}>
        {parsedData.map((data) => (
          <button
            type="button"
            key={data.key}
            className={classNames({
              [styles.btnActive]: currentData.key === data.key
            })}
            onClick={() => handleCurrentData(data)}
          >
            <Typograph
              htmlTag="p"
              size="medium"
              weight="bold"
              color="outer_space"
            >
              {data.label}
            </Typograph>
          </button>
        ))}
      </div>

      <canvas ref={canvasRef} height={230} />
    </div>
  )
}

Chart.defaultProps = {
  profileData: []
}

Chart.propTypes = {
  profileData: PropTypes.array
}

const mapStateToProps = () => {
  return {}
}

const enhance = connect(mapStateToProps, {})

export default enhance(Chart)



// WEBPACK FOOTER //
// ./src/scenes/ConsumptionProfile/components/Chart/index.js